<script setup></script>

<template>
  <div class="w-[360px]" aria-hidden="true">
    <div class="h-[120px] rounded-t-[var(--radius)] bg-muted animate-pulse" />
    <div class="relative px-5 pt-0 pb-5">
      <div
        class="absolute -top-11 left-5 h-[88px] w-[88px] rounded-full ring-2 ring-white bg-muted animate-pulse"
      />
      <div class="pt-14 flex flex-col gap-3">
        <div class="h-5 w-1/2 rounded-[var(--radius)] bg-muted animate-pulse" />
        <div class="h-4 w-2/3 rounded-[var(--radius)] bg-muted animate-pulse" />
        <div class="h-4 w-1/3 rounded-[var(--radius)] bg-muted animate-pulse" />
        <div class="space-y-2 pt-1">
          <div
            class="h-3 w-full rounded-[var(--radius)] bg-muted animate-pulse"
          />
          <div
            class="h-3 w-11/12 rounded-[var(--radius)] bg-muted animate-pulse"
          />
          <div
            class="h-3 w-9/12 rounded-[var(--radius)] bg-muted animate-pulse"
          />
        </div>
        <div class="space-y-2 pt-2">
          <div
            class="h-4 w-2/3 rounded-[var(--radius)] bg-muted animate-pulse"
          />
          <div
            class="h-4 w-1/2 rounded-[var(--radius)] bg-muted animate-pulse"
          />
          <div
            class="h-4 w-1/2 rounded-[var(--radius)] bg-muted animate-pulse"
          />
        </div>
      </div>
    </div>
  </div>
</template>
